import { computed } from "vue";
import { usePage } from "@inertiajs/vue3";
import { useLocalisedTzFormat } from "@/composables/useLocalisedTzFormat";
import { convertTimeToDateUTC } from "@/utils/convertTimeToDate";
import type { Days } from "../types";

export function useEditableDays(availability: any) {
    const page = usePage();
    const timezone = computed(() => page.props.timezone);
    const { format } = useLocalisedTzFormat();

    const editableDays = computed(function () {
        const days: Days = {
            0: {
                intervals: [],
                enabled: true,
            },
            1: {
                intervals: [],
                enabled: true,
            },
            2: {
                intervals: [],
                enabled: true,
            },
            3: {
                intervals: [],
                enabled: true,
            },
            4: {
                intervals: [],
                enabled: true,
            },
            5: {
                intervals: [],
                enabled: false,
            },
            6: {
                intervals: [],
                enabled: false,
            },
        };

        // @ts-expect-error
        availability.availability_dates.forEach((availabilityDate, key) => {
            const start = format(
                convertTimeToDateUTC(availabilityDate.start),
                "HH:mm",
                {
                    timeZone: timezone.value as string,
                },
            );

            const end = format(
                convertTimeToDateUTC(availabilityDate.end),
                "HH:mm",
                {
                    timeZone: timezone.value as string,
                },
            );

            // @ts-expect-error
            days[availabilityDate.day].intervals.push({
                key: key,
                day: availabilityDate.day,
                startError: false,
                endError: false,
                start: start,
                end: end,
            });

            // @ts-expect-error
            days[availabilityDate.day].enabled = availabilityDate.enabled;
        });

        return days;
    });

    return {
        days: editableDays,
    };
}
